import { useContext } from "react"
import { ConsentContext, ConsentContextValue } from "./ConsentContext"

export const useConsent = (): ConsentContextValue => {
  const ctx = useContext(ConsentContext)
  if (!ctx) {
    throw new Error("useConsent must be used inside ConsentProvider")
  }
  return ctx
}

// Read-only accessor reflecting geo-scoped defaults. Safe fallback when
// no provider is mounted (SSR, tests, misconfigured trees) is strict-off.
export const useConsentGranted = () => {
  const ctx = useContext(ConsentContext)
  if (!ctx) return { analytics: false, marketing: false }
  return ctx.granted
}
